import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import Head from 'next/head'

import {t} from '@lib/helpers'

import Meta from '@components/Meta'
import PolicySecurity from '@components/PolicySecurity'

const Security = ({}) => {
  return <PolicySecurity contentKey='security' />
}

Security.propTypes = {}

export default Security
